import { WorkflowTab } from '@/components/common';

export type EmbryoEditTab =
  | 'general'
  | 'implant'
  | 'freezing'
  | 'qc'
  | 'additional'
  | 'meritInfo'
  | 'recipStatus'
  | 'calves'
  | 'notes';

export const embryoEditTabs: WorkflowTab<EmbryoEditTab>[] = [
  {
    key: 'general',
    label: 'General',
    icon: 'pi pi-info-circle',
  },
  {
    key: 'implant',
    label: 'Implant/Transfer',
    icon: 'pi pi-send',
  },
  {
    key: 'freezing',
    label: 'Freezing',
    icon: 'pi pi-minus-circle',
  },
  {
    key: 'qc',
    label: 'QC',
    icon: 'pi pi-check-square',
  },
  {
    key: 'meritInfo',
    label: 'Merit Info',
    icon: 'pi pi-chart-bar',
  },
  {
    key: 'recipStatus',
    label: 'Recip Status',
    icon: 'pi pi-heart',
  },
  {
    key: 'additional',
    label: 'Additional Info',
    icon: 'pi pi-database',
  },
  {
    key: 'calves',
    label: 'Calves',
    icon: 'pi pi-list',
  },
  {
    key: 'notes',
    label: 'Notes',
    icon: 'pi pi-comment',
  },
];

const regularOnlyTabs: EmbryoEditTab[] = [
  'qc',
  'meritInfo',
  'recipStatus',
  'calves',
  'notes',
];

const singleOnlyTabs: EmbryoEditTab[] = ['notes'];

export const outsideEmbryoEditTabs: WorkflowTab<EmbryoEditTab>[] =
  embryoEditTabs.filter((tab) => !regularOnlyTabs.includes(tab.key));

export const bulkEmbryoEditTabs: WorkflowTab<EmbryoEditTab>[] =
  embryoEditTabs.filter((tab) => !singleOnlyTabs.includes(tab.key));

export const dateFields = [
  'creation',
  'modifiedOn',
  'receivedOn',
  'implantDate',
  'heat1',
  'dateUsed',
  'estDueDate',
  'qcEmbHoldingExpDate',
  'qcSucroseDate',
  'qcEg10Date',
  'qcTryPsInDate',
  'qcehmDate',
  'transferDate',
  'pc1Date',
  'pc2Date',
  'pc3Date',
  'pc4Date',
  'pc5Date',
  'pc6Date',
  'pc7Date',
  'pc8Date',
  'pc9Date',
  'scHnDate',
  'scIpDate',
  'scRpDate',
  'scPreviousHeat',
  'scLastHeat',
  'scSyDate',
  'recipBirthDate',
  'recipCalvingDate',
] as const;
